import React from "react";
import queryString from "query-string";
import { FormattedHTMLMessage } from "react-intl";
import { Route } from "react-router-dom";
import MainMenu from "../components/MainMenu";


const NewEnergy = React.createClass({
  render() {
    const { location } = this.props;
    const query = queryString.parse(location.search || "?l=it");
    const languageID = query.l || "it";

    return (
      <div>
        <div className='NewEnergy-desktop'>
          <div className='NewEnergy-container'>
            <Route path='/' component={MainMenu} />
            <div className='NewEnergy'>
              <div className={`NewEnergy-content language-${languageID}`}>
                <div className='NewEnergy-title'>
                  {<FormattedHTMLMessage id={"pages:new-energy:title"} />}
                </div>
                <div className='NewEnergy-description'>
                  {<FormattedHTMLMessage id={"pages:new-energy:description"} />}
                </div>
              </div>
              <div className='NewEnergy-images'>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/energy_1.jpg")'
                  }}
                ></div>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/energy_2.jpg")'
                  }}
                ></div>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/energy_3.jpg")'
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div className='NewEnergy-mobile'>
          <div className='NewEnergy-container'>
            <Route path='/' component={MainMenu} />
            <div className='NewEnergy'>
              <div className='NewEnergy-images'>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/energy_1.jpg")'
                  }}
                ></div>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/energy_2.jpg")'
                  }}
                ></div>
                <div
                  style={{
                    backgroundImage: 'url("images/backgrounds/energy_3.jpg")'
                  }}
                ></div>
              </div>
              <div className='NewEnergy-content'>
                <div className='NewEnergy-title'>
                  {<FormattedHTMLMessage id={"pages:new-energy:title"} />}
                </div>
                <div className='NewEnergy-description'>
                  {<FormattedHTMLMessage id={"pages:new-energy:description"} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
})

export default NewEnergy;



// WEBPACK FOOTER //
// ./src/sections/NewEnergy.js